import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { Dropzone } from "../../../components/Dropzone/Dropzone";
import { uploadPDFImage } from "./api";
import Grid from "@mui/material/Grid2";

export default function FacilityImageUpload(props) {

  const classes = {
    dropZone: {
      display: "flex",
      justifyContent: "center",
      padding: "0 5rem",
    },
  }

  const { handleSnackbar, setState } = props;
  const [loading, setLoading] = useState(false);
  return (
    (<Grid container size={12} sx={classes.dropZone}>
      <Grid size={12}>
        {loading ? (
          <CircularProgress />
        ) : (
          <Dropzone
            accept="application/pdf, image/png"
            acceptText="Drag and drop or click to select file. Accepted file types are PDF and PNG."
            callback={(acceptedFiles, accepted) => {
              setLoading(true);
              accepted(true);
              uploadPDFImage({...props, file:acceptedFiles, handleSnackbar, setState, setLoading})
            }}
            clearFile={() => {
              console.log("clear files");
            }}
          />
        )}
      </Grid>
    </Grid>)
  );
}
